<div class="flex items-start gap-md">
  <sb-switch [formControl]="hubSpotChatStatusCtrl" [ariaLabel]="'Chat' | translate" />
  <sb-support-text-block
    [title]="'Chat' | translate"
    [body]="
      hasConsent()
        ? ('Activate to start chatting with one of the experts on our support team.' | translate)
        : ('By enabling the chat bubble, you agree to have your name and email address stored for support purposes.'
          | translate)
    "
  />
</div>
